import * as React from "react";
import "./AdminContainer.css";

export default class AdminContainer extends React.Component {
	render() {
		return <div className="admin-box">{this.props.children}</div>;
	}
}
